import { notification } from "antd";
import Api from "../../api";
import API_URL from "../../api/url";
import { SetToken, DeleteToken, SetAcessToken } from "../../utils";
import { decryptData, encryptedData } from "../../utils";
import {
  setUserList,
  setRoleList,
  setRoleDetail,
  setUserDetail,
  setFilterData
} from "../Slices/userSlice";
import { RoleId, Permission, GetLoggedInUser } from "../../utils";
import store from "../store";

export const loginAuth = (data) => async (dispatch) => {
  try {
    const res = await Api.get(API_URL.LOGIN_AUTH, { data: data });
    if (res.status === 200) {
      SetAcessToken(res?.data?.result);
      // const plainTxt = decryptData(res?.data?.result);
      // if (plainTxt) {
      //   /**
      //    * Decrypt
      //    */
      //   const cypherText = encryptedData(plainTxt);
      //   if (cypherText) {
      //     SetAcessToken(cypherText);
      //   }
      // }
    }
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const loginApi = (data, navigate) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.LOGIN, data);
    // console.log(res, "===");

    if (res.status === 200) {
      SetToken(res?.data?.result.token || "");
      const UserData = GetLoggedInUser();
      // console.log(UserData, "UserData");

      const Permission = UserData?.permission
        ? JSON.parse(UserData?.permission)
        : null;
      if (Permission) {
        if (Permission[0]["module"] == "HIU Dashboard") {
          window.location.pathname = "/hiu-dashboard";
        } else if (Permission[0]["module"] == "HIP Dashboard") {
          window.location.pathname = "/hip-dashboard";
        } else {
          window.location.pathname = "/users";
        }
      } else {
        console.log("Empty permission");
      }

      notification["success"]({
        message: "Login Successfully"
      });
    }
    return res;
  } catch (err) {
    if (err.response?.data?.message) {
      notification["error"]({
        message: err.response.data.message
      });
    }
    return err;
  }
};
export const fetchRolesApi = (data, UserId) => async (dispatch) => {
  try {
    const res = await Api.get(API_URL.ROLE_LIST, {
      data: data,
      params: UserId
    });
    dispatch(
      setRoleList({ list: res.data.result, total: res.data.dataLength })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message: error.response?.data?.message || error.message
    });
    return error;
  }
};
export const addRolesApi = (data, navigate) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.ROLE_ADD, data);
    navigate("/roles");
    notification["success"]({
      message: "Role created successfully!"
    });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.message?.role ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};
export const updateRolesApi = (data, id, navigate) => async (dispatch) => {
  try {
    const res = await Api.put(`${API_URL.ROLE_UPDATE}/${id}`, data);
    navigate("/roles");
    notification["success"]({
      message: "Role updated successfully!"
    });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.message?.role ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};
export const fetchRolesByIdApi = (data, id, params) => async (dispatch) => {
  try {
    const res = await Api.post(`${API_URL.ROLE_BY_ID}/${id}`, params, data);
    dispatch(setRoleDetail(res.data.result));
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message ||
        ""
    });
    return error;
  }
};

export const fetchFilterDataApi = (params, user) => async (dispatch) => {
  try {
    const res = await Api.get(API_URL.FILTER_DATA, { params: user });
    dispatch(setFilterData({ list: res.data.result }));
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message ||
        ""
    });
    return error;
  }
};
export const updatePermissionApi = (data, id, navigate) => async (dispatch) => {
  try {
    const res = await Api.put(`${API_URL.PERMISSION_UPDATE}/${id}`, data);
    navigate("/roles");
    notification["success"]({
      message: "Permission updated successfully!"
    });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message ||
        ""
    });
    return error;
  }
};
export const fetchUsersApi = (data) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.USER_LIST, data);
    dispatch(
      setUserList({ list: res.data.result, total: res.data.dataLength })
    );
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message ||
        ""
    });
    return error;
  }
};
export const addUsersApi = (data, navigate) => async (dispatch) => {
  try {
    const res = await Api.post(API_URL.USER_ADD, data);
    navigate("/users");
    notification["success"]({
      message: "User created successfully!"
    });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.result?.email ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};
export const updateUsersApi = (data, id, navigate) => async (dispatch) => {
  try {
    const res = await Api.put(`${API_URL.USER_UPDATE}/${id}`, data);
    navigate("/users");
    notification["success"]({
      message: "User updated successfully!"
    });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.message?.email ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};
export const updateUserStatusApi = (data, id) => async (dispatch) => {
  try {
    const res = await Api.put(`${API_URL.USER_STATUS_UPDATE}/${id}`, data);
    notification["success"]({
      message: "User Status updated successfully!"
    });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};

export const logoutUserApi = async (dispatch) => {
  try {
    const res = await Api.post(`${API_URL.LOG_OUT}`, {});
    // notification["success"]({
    //   message: "User Status updated successfully!"
    // });
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};
export const updateUserPasswordApi =
  (data, id, navigate) => async (dispatch) => {
    try {
      const res = await Api.put(`${API_URL.UPDATE_PASSWORD}/${id}`, data);
      store?.dispatch({ type: "LOGOUT" });
      DeleteToken();
      window.location.href = "/login";
      notification["success"]({
        message: "User password changed successfully, you need to login again."
      });
      return res;
    } catch (error) {
      notification["error"]({
        message:
          error.response?.data?.Message ||
          error.response?.data?.message ||
          error.message
      });
      return error;
    }
  };
export const fetchUsersByIdApi = (data, id) => async (dispatch) => {
  try {
    const res = await Api.post(`${API_URL.USER_BY_ID}/${id}`, data);
    dispatch(setUserDetail(res.data.result));
    return res;
  } catch (error) {
    notification["error"]({
      message:
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message
    });
    return error;
  }
};
